"use client";
import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/admin/ui/button";
import { Calendar } from "@/components/admin/ui/calendar";

function formatDate(d?: Date | null): string {
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function parseDate(s?: string | null): Date | undefined {
  if (!s) return undefined;
  const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(String(s));
  if (!m) return undefined;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  const dt = new Date(Date.UTC(y, mo, d));
  if (isNaN(dt.getTime())) return undefined;
  return new Date(y, mo, d);
}

export function DateField({
  value,
  onChange,
  placeholder = 'YYYY-MM-DD',
  className = '',
}: {
  value?: string | null;
  onChange: (value?: string | null) => void;
  placeholder?: string;
  className?: string;
}) {
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState<Date | undefined>(parseDate(value || ''));
  React.useEffect(() => { setSelected(parseDate(value || '')); }, [value]);

  return (
    <>
      <button
        type="button"
        className={["admin-input", className].filter(Boolean).join(' ')}
        onClick={() => setOpen(true)}
      >
        <span className={value ? '' : 'text-muted-foreground'}>{value || placeholder}</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Select date</DialogTitle>
          </DialogHeader>
          <Calendar
            mode="single"
            selected={selected}
            onSelect={(d) => setSelected(d || undefined)}
          />
          <DialogFooter>
            <Button variant="outline" size="sm" onClick={() => { setSelected(undefined); onChange(''); setOpen(false); }}>Clear</Button>
            <Button size="sm" onClick={() => { onChange(formatDate(selected)); setOpen(false); }}>Apply</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default DateField;

